import {QuestionIcon} from "@/config/config";
import {Popover} from "antd";


const CommonQuestionPop = ({content, children}) =>{
  const pop = <div className={"w-[247px] text-[#fff]"}>
    {content}
  </div>;


  return <Popover color={"#4E4E4EE5"} content={pop}>
    {children}
  </Popover>;

};

export default CommonQuestionPop;
